import React from 'react';
import type { ReviewWorkflowStatus } from '../types';
import { WORKFLOW_LABELS } from '../types';

// 5-state locked system — identical across all Rascal Republic apps
const STATUS_STYLE: Record<ReviewWorkflowStatus, { bg: string; text: string; icon: string }> = {
  prep_window:       { bg: 'bg-gray-100',   text: 'text-gray-500',   icon: '○' },
  self_pending:      { bg: 'bg-amber-50',   text: 'text-amber-700',  icon: '⚠' },
  self_submitted:    { bg: 'bg-blue-50',    text: 'text-blue-700',   icon: '⟳' },
  '360_pending':     { bg: 'bg-amber-50',   text: 'text-amber-700',  icon: '⚠' },
  '360_collected':   { bg: 'bg-blue-50',    text: 'text-blue-700',   icon: '⟳' },
  manager_pending:   { bg: 'bg-amber-50',   text: 'text-amber-700',  icon: '⚠' },
  manager_submitted: { bg: 'bg-blue-50',    text: 'text-blue-700',   icon: '⟳' },
  calibration:       { bg: 'bg-amber-50',   text: 'text-amber-700',  icon: '⚠' },
  approved:          { bg: 'bg-emerald-50', text: 'text-emerald-700',icon: '✓' },
  signed_off:        { bg: 'bg-emerald-50', text: 'text-emerald-700',icon: '✓' },
};

interface Props {
  status: ReviewWorkflowStatus;
  size?: 'sm' | 'md';
}

const WorkflowStatusBadge: React.FC<Props> = ({ status, size = 'md' }) => {
  const s = STATUS_STYLE[status];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${s.bg} ${s.text} ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      }`}
    >
      <span aria-hidden="true">{s.icon}</span>
      {WORKFLOW_LABELS[status]}
    </span>
  );
};

export default WorkflowStatusBadge;
